import { Datepicker } from "vanillajs-datepicker";
import { DateRangePicker } from "vanillajs-datepicker";
import vi from "/node_modules/vanillajs-datepicker/js/i18n/locales/vi.js";
import zhCN from "/node_modules/vanillajs-datepicker/js/i18n/locales/zh-CN.js"; // Traditional
import zhTW from "/node_modules/vanillajs-datepicker/js/i18n/locales/zh-TW.js"; // Simplified
import { ClassWatcher } from "./classWatcher.js";

var elemental = require("./elem/elem.js");

// Assign Locale Data
Object.assign(Datepicker.locales, vi);
Object.assign(Datepicker.locales, zhCN);
Object.assign(Datepicker.locales, zhTW);

// JavaScript Language Switcher
const $lang = document.querySelector("[data-language]").dataset.language;
let $language = "en";

// Switch Languages
if ($lang == "zh-hant") {
  $language = "zh-CN";
}

if ($lang == "zh-hans") {
  $language = "zh-TW";
}

if ($lang == "vi") {
  $language = "vi";
}

// Initialise date-pickers
// const elems = document.querySelectorAll('.date-picker');

// // Loop around all datepickers
// elems.forEach((elem) => {

//   let datepicker = new Datepicker(elem, {
//     format: 'dd.mm.yy',
//     language : $language,
//     //minDate : new Date(Date.now())
//   });

//   // Date Set
//   var today = new Date();

//   // Increment by Days
//   if(elem.dataset.dateset) {
//     today.setDate(today.getDate() + Number(elem.dataset.dateset));
//     //
//   }
//   // Set the Date
//   datepicker.setDate(today);

// //   elem.querySelectorAll('.date-picker .datepicker-cell').forEach((dates) => {
// //     setTimeout(() => {
// //         elem.dataset.dateset = datepicker.getDate('yy-mm-dd');
// //     });
// //   });

// //   datepicker.changeDate(() => {
// //     elem.dataset.dateset = datepicker.getDate('yy-mm-dd');
// //   });

// });

function timeConverter(UNIX_timestamp) {
  var a = new Date(UNIX_timestamp);
  var months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var time = date + "." + month + "." + year;
  return time;
}

// Set up Availability bar datepicker
const rangePickerElem = document.getElementById("range");

// ** A note to future developers,
// The date-picker multi-language used
// requires the datepicker to be used at -2000 years
// to meet the reqiurements of the dd.mm.yy format
// rather than the traditional dd.mm.yyyy.
// This is not bad coding on our part, but
// bad coding as a result of the chosen plugin. **

if (rangePickerElem) {
  const rangeInputs = rangePickerElem.querySelectorAll("input");
  const rangepicker = new DateRangePicker(rangePickerElem, {
    // ...options
    format: "dd.mm.yy",
    language: $language,
    orientation: "left top",
    container: "#range-container",
    allowOneSidedRange: true,
    minDate: new Date(Date.now() - 63113900000000),
  });

  // Set Initial Dates
  let newdate = new Date(Date.now() - 63113900000000);
  let newenddate = new Date(Date.now() - 63113350000000);

  const datecache = {
    start: (newdate = newdate.setDate(newdate.getDate())),
    end: newenddate.setDate(newenddate.getDate()),
    tempend: newenddate.setDate(newenddate.getDate()),
    remove: { clear: true },
  };

  const initDate = (start, end) => {
    rangepicker.setDates(start, end);
  };

  initDate(datecache.start, datecache.end);

  // Select inputs
  const selectDpRange = document.querySelectorAll("#range input");
  const selectDpPickers = document.querySelectorAll(".datepicker-dropdown");

  const dpClassAdded = (e) => {};

  const dpClassRemoved = (e) => {
    if (datecache.tempend !== null) {
      rangepicker.datepickers[1].setDate(datecache.tempend);
      //selectDpRange[1].value = timeConverter(datecache.tempend);
    }
  };

  // Create a class watcher for .datepicker on active class
  selectDpPickers.forEach((pickers) => {
    let classWatcher = new ClassWatcher(
      pickers,
      "active",
      dpClassAdded,
      dpClassRemoved
    );
  });

  // On input click
  selectDpRange.forEach((dps, i) => {
    dps.addEventListener("click", (e) => {
      if (i == 0) {
        if (!dps.classList.contains("been-selected")) {
          initDate("", datecache.remove);
          selectDpRange[1].placeholder = timeConverter(datecache.end);
        }
      }
    });
  });

  // Select Dropdown
  selectDpPickers.forEach((dps, i) => {
    dps.querySelectorAll(".datepicker-cell").forEach((dates) => {
      dates.addEventListener("click", (event) => {
        setTimeout(() => {
          if (i == 0) {
            // First Datepicker
            if (datecache.tempend == null) {
              // If Date Temp End is Null
              console.error("1");
              rangepicker.datepickers[0].hide();
              rangeInputs[1].focus();
              dps.classList.remove("active");

              let setDate = new Date(parseInt(dates.dataset.date));
              setDate = setDate.setDate(setDate.getDate() + 7);

              initDate("", setDate);
              datecache.end = setDate;
            } else if (dates.dataset.date >= datecache.tempend) {
              // If Date Selection is More than END Date Cache

              let testDate = new Date(parseInt(dates.dataset.date));

              let setDate = new Date(parseInt(dates.dataset.date));
              setDate = setDate.setDate(setDate.getDate() + 7);

              datecache.end = setDate;
              datecache.tempend = setDate;

              // initDate("", setDate);

              rangeInputs[1].focus();

              rangepicker.datepickers[0].hide();
            } else {
              // If the Date Selection is Less than the END Date Cache
              console.error("3");
              rangepicker.datepickers[0].hide();

              rangeInputs[1].focus();
              dps.classList.remove("active");

              initDate("", datecache.tempend);
            }
          }

          if (i == 1) {
            dps.classList.add("been-selected");

            let setDate = new Date(parseInt(dates.dataset.date));
            setDate = setDate.setDate(setDate.getDate());

            datecache.tempend = setDate;
            datecache.end = setDate;
            selectDpRange[1].placeholder = timeConverter(datecache.tempend);
          }
        }, 50);
      });
    });
  });
}

// Get Date Format // Book Now Date Picker
function getDate(dateModifier = null) {
  const monthNames = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const dateObj = new Date();

  if (dateModifier) {
    dateObj.setDate(dateObj.getDate() + dateModifier);
  }

  const month = monthNames[dateObj.getMonth()];
  const day = String(dateObj.getDate()).padStart(2, "0");
  const year = dateObj.getFullYear().toString().substr(-2);
  const output = day + "." + month + "." + year;

  return output;
}

// Convert Date Format to Reasonable Date
function convertDate(dateModifier = null) {
  const monthNames = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const dateObj = new Date();

  if (dateModifier) {
    dateObj.setDate(dateObj.getDate() + dateModifier);
  }

  const month = monthNames[dateObj.getMonth()];
  const day = String(dateObj.getDate()).padStart(2, "0");
  const year = dateObj.getFullYear().toString().substr(-2);
  const output = day + "." + month + "." + year;

  return output;
}

// Select all data-pickers
const bookNowDatePicker = document.querySelectorAll(".book-now-date-picker");

// Data Value Mutation Observer Callback
const dataValueMutationCallback = (mutationsList) => {
  for (const mutation of mutationsList) {
    if (
      mutation.type !== "attributes" ||
      mutation.attributeName !== "data-value"
    ) {
      return;
    }

    let backToFirst = 2;

    let hasFlights =
      document.querySelector("[data-current-interest]").dataset
        .currentInterest < 3
        ? true
        : false;

    if (hasFlights) {
      backToFirst = 2; // Apartments & Hotel Rooms

      if (mutation.target.dataset.id - 1 == 3) {
        // Last Item Exception
        bookNowDatePicker[3].classList.remove("book-now-date-picker-active");
        bookNowDatePicker[backToFirst].classList.add(
          "book-now-date-picker-active"
        );
      } else {
        // Transition
        bookNowDatePicker[mutation.target.dataset.id - 1].classList.remove(
          "book-now-date-picker-active"
        );
        bookNowDatePicker[mutation.target.dataset.id].classList.add(
          "book-now-date-picker-active"
        );
      }
    } else {
      backToFirst = 0; // Flights

      if (mutation.target.dataset.id - 1 == 1) {
        // Last Item Exception
        bookNowDatePicker[1].classList.remove("book-now-date-picker-active");
        bookNowDatePicker[backToFirst].classList.add(
          "book-now-date-picker-active"
        );
      } else {
        // Transition
        bookNowDatePicker[mutation.target.dataset.id - 1].classList.remove(
          "book-now-date-picker-active"
        );
        bookNowDatePicker[mutation.target.dataset.id].classList.add(
          "book-now-date-picker-active"
        );
      }
    }
  }
};

// Data Value Mutation Observer
const observer = new MutationObserver(dataValueMutationCallback);

// Book Now Datepicker Logics
bookNowDatePicker.forEach((elem, i) => {
  let dataid = elem.dataset.id;

  dataid == 1 ? (elem.value = getDate()) : ""; // Departure
  dataid == 2 ? (elem.value = getDate(+1)) : ""; // Returning
  dataid == 3 ? (elem.value = getDate()) : ""; // Checkin
  dataid == 4 ? (elem.value = getDate(+1)) : ""; // Checkout

  // elem.addEventListener("click", (el) => {
  //   console.log(elem.value );
  //   if(i == 0) {
  //     //bookNowDatePicker[1].value = bookDatePicker.setDate(elem.value + 7);

  //     let setDate = new Date(parseInt(elem.value));
  //     setDate = setDate.setDate(setDate.getDate() + 7);

  //     console.log(setDate);
  //   }

  //   if(i == 1) {

  //   }

  //   if(i == 2) {

  //   }

  //   if(i == 3) {

  //   }
  // });

  // Click Logic. Click on a box, add event listener.
  elem.addEventListener("click", (e) => {
    bookDatePicker.setDate(elem.value);

    document
      .querySelector("#book-now-form-cal")
      .classList.remove("book-now-form-cal-disabled");

    let className = "book-now-date-picker-active";

    bookNowDatePicker.forEach((elemx) => {
      elemx.classList.remove(className);
    });

    e.target.classList.add(className);
    document.querySelector("body").classList.add("booknow-datepicker-active");
  });

  observer.observe(elem, { attributes: true });
});

// Book Now Datepicker Logic
const elem = document.getElementById("book-now-form-cal");
const bookDatePicker = new Datepicker(elem, {
  format: "dd.mm.yy",
  language: $language,
  minDate: new Date(Date.now() - 63113900000000),
});

var today = new Date();
// Increment by Days
if (elem.dataset.dateset) {
  today.setDate(today.getDate() + Number(elem.dataset.dateset));
}
// Set the Date
document
  .querySelectorAll(".book-now-partial .datepicker-cell") // On DatePicker Cell
  .forEach((dates) => {
    dates.addEventListener("click", () => {
      //bookDatePicker.setDate(today);
      setTimeout(() => {
        let getAllValues = [
          ...document.querySelectorAll(
            ".book-now-partial .book-now-date-picker"
          ),
        ];
        let getCurrentSelection = document.querySelector(
          ".book-now-partial .book-now-date-picker-active"
        );

        getCurrentSelection.value = bookDatePicker.getDate("dd.mm.yy"); // Get the Date and add to value
        getCurrentSelection.dataset.value =
          "20" + bookDatePicker.getDate("yy-mm-dd");

        function padNumber(number) {
          var string = "" + number;
          string = string.length < 2 ? "0" + string : string;
          return string;
        }

        if (getAllValues[0] == getCurrentSelection) {
          // If first item is selected

          getAllValues[0].classList.remove(".book-now-departing-value");

          // Mimic
          getAllValues[2].value = bookDatePicker.getDate("dd.mm.yy");
          getAllValues[2].dataset.value =
            "20" + bookDatePicker.getDate("yy-mm-dd");

          // Set Next Date and Values (The actual dataset field);
          let date = new Date("20" + bookDatePicker.getDate("yy-mm-dd"));
          let next_date = new Date(date.setDate(date.getDate() + 7));
          let formatted =
            next_date.getUTCFullYear() +
            "-" +
            padNumber(next_date.getUTCMonth() + 1) +
            "-" +
            padNumber(next_date.getUTCDate());
          getAllValues[1].dataset.value = formatted; // Set Dataset Value
          getAllValues[3].dataset.value = formatted; // Mimic

          // Set the Values (The actual value field)
          date = new Date("20" + bookDatePicker.getDate("yy-mm-dd"));
          next_date = new Date(date.setDate(date.getDate() + 7));
          formatted =
            padNumber(next_date.getUTCDate()) +
            "." +
            padNumber(next_date.getUTCMonth() + 1) +
            "." +
            (next_date.getUTCFullYear() - 2000);
          getAllValues[1].value = formatted; // Set Input Field Value
          getAllValues[3].value = formatted; // Mimic
        }

        if (getAllValues[1] == getCurrentSelection) {
          // If first item is selected

          // Set Next Date and Values (The actual dataset field);
          let date = new Date("20" + bookDatePicker.getDate("yy-mm-dd"));
          let next_date = new Date(date.setDate(date.getDate()));
          let formatted =
            next_date.getUTCFullYear() +
            "-" +
            padNumber(next_date.getUTCMonth() + 1) +
            "-" +
            padNumber(next_date.getUTCDate());
          getAllValues[3].dataset.value = formatted; // Mimic

          // Set the Values (The actual value field)
          date = new Date("20" + bookDatePicker.getDate("yy-mm-dd"));
          next_date = new Date(date.setDate(date.getDate()));
          formatted =
            padNumber(next_date.getUTCDate()) +
            "." +
            padNumber(next_date.getUTCMonth() + 1) +
            "." +
            (next_date.getUTCFullYear() - 2000);
          getAllValues[3].value = formatted; // Mimic
        }
      }, 10);
    });
  });

// Prepend Datepicker
document.querySelectorAll(".datepicker-picker").forEach((elem) => {
  elem.prepend(
    elemental.elem(
      '<span class="datepicker-branding"><span class="dpb-left"></span><span class="dpb-logo"></span><span class="dpb-right"></span></span>'
    )
  );
});
